import Events from "./Classes/Events.js"
const EventBus = new Events();
document.eb = EventBus;
export default EventBus;
